var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGlobalError = function SvgGlobalError(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 321,
    height: 321,
    viewBox: "0 0 321 321",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M165.845 95.597l-29.711-51.46-16.138 9.322 29.713 51.46 16.136-9.322zM202.375 112.166l45.15-38.684-12.175-14.15-45.092 38.683 12.117 14.151z",
    fill: "#096885"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M286.501 219.088c-3.496-12.817-11.07-23.303-20.974-31.459 6.408-18.06-1.166-38.451-18.061-48.355l-39.614 69.91c15.147 8.739 33.206 6.409 45.44-4.078 6.409 4.661 10.488 11.652 12.818 19.226 2.913 9.321 1.165 19.225-3.496 27.964l18.643 10.486c7.573-12.816 9.904-28.546 5.244-43.694z",
    fill: "#096885"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M181.635 182.385l26.216 27.382 39.615-69.911-36.12-9.904-29.711 52.433z",
    fill: "#096885"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M160.662 163.16l-6.991-12.817-28.548 14.564-9.903-16.895 28.547-15.147-6.992-12.817-29.129 15.147-7.573-12.816-31.46 18.06c-16.895 9.321-23.886 29.129-18.643 46.607-6.99 6.408-12.816 15.729-15.73 26.216-4.077 15.147-2.33 30.877 5.243 44.277l18.643-10.487c-4.66-8.739-5.825-18.643-3.495-27.964 1.166-5.243 4.079-9.904 7.574-13.982 12.234 11.069 30.877 13.399 46.024 4.661l31.459-18.061-7.572-13.399 28.546-15.147zM204.938 188.211a9.899 9.899 0 009.904-9.904 9.9 9.9 0 00-9.904-9.904 9.9 9.9 0 00-9.905 9.904 9.9 9.9 0 009.905 9.904zM218.919 161.995a9.9 9.9 0 009.904-9.904 9.899 9.899 0 00-9.904-9.904 9.898 9.898 0 00-9.903 9.904 9.9 9.9 0 009.903 9.904z",
    fill: "#096885"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGlobalError);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "global-error.0236c05805aa3b075df4dd8f63257f14.svg";